@switch (dialogId) {
  @case ('dialog-logout') {
    <div id="dialog-logout"
    class="bg-white dark:bg-slate-700 border dark:border-slate-700 rounded-lg">
    <div id="icon" class="pt-8 animate-flip-up animate-duration-[800ms] animate-delay-490 text-center">
      <mat-icon ngClass="{{data.colorIcon}}">logout</mat-icon>
    </div>
    <h1 class="text-center pt-4 font-medium text-lg dark:text-gray-400 text-gray-800">{{ data.message }}</h1>
    <div mat-dialog-content class="h-full text-center">
      <p class="h-full text-center text-gray-800 dark:text-gray-400">Tendras que volver a iniciar sesión</p>
    </div>
    <div mat-dialog-actions class="flex justify-content-between">
      <button mat-flat-button color="warn" (click)="onConfirm()" cdkFocusInitial>Si, Cerrar sesión</button>
      <span class="spacer"></span>
      <button mat-flat-button color="primary" (click)="onNoClick()">No, Cancelar</button>
    </div>
  </div>
  }
  @case ('dialog-deleted') {
    <div id="dialog-deleted"
    class="bg-white dark:bg-slate-700 border dark:border-slate-700 rounded-lg">
    <div id="icon" class="pt-8">
      <svg aria-hidden="true" class="mx-auto text-amber-400 w-14 h-14 dark:text-amber-200" fill="none"
        stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
        d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
      </svg>
    </div>
    <h1 mat-dialog-title class="text-center">¿Está seguro?</h1>
    <div mat-dialog-content class="h-full text-center">
      <p class="h-full text-center">Este proceso no es reversible, está a punto de eliminar</p> el centro de operación {{data.message}}
    </div>
    <div mat-dialog-actions class="flex justify-content-between">
      <button mat-flat-button color="warn" (click)="onConfirm()" cdkFocusInitial>Si, Estoy seguro</button>
      <span class="spacer"></span>
      <button mat-flat-button color="primary" (click)="onNoClick()">No, Cancelar</button>
    </div>
  </div>
  }
  @case ('dialog-error') {
    <div id="dialog-error"
    class="bg-white dark:bg-slate-700 border dark:border-slate-700 rounded-lg">
    <div id="icon" class="pt-8 bounce-top">
      <svg aria-hidden="true" class="mx-auto text-amber-400 w-14 h-14 dark:text-amber-200" fill="rgb(242, 116, 116)"
        stroke="currentColor" viewBox="0 -960 960 960" xmlns="http://www.w3.org/2000/svg">
        <path d="M330.539-289.539 480-439.001l149.461 149.462 41-41L520.999-480l149.462-149.461-41-41L480-520.999 330.539-670.461l-41 41L439.001-480 289.539-330.539l41 41Zm149.07 205.537q-81.403 0-153.419-31.439-72.016-31.44-125.649-85.05-53.634-53.611-85.087-125.727-31.453-72.117-31.453-153.715 0-82.108 31.499-154.353 31.499-72.246 85.396-126.152 53.898-53.905 125.652-84.733 71.755-30.828 152.942-30.828 82.165 0 154.716 30.815 72.552 30.814 126.239 84.71 53.688 53.896 84.621 126.275 30.933 72.38 30.933 154.674 0 81.679-30.815 153.193-30.814 71.515-84.697 125.411t-126.244 85.408q-72.361 31.512-154.634 31.512Zm.391-58.383q140.205 0 238.91-99.013Q817.615-340.411 817.615-480q0-140.205-98.705-238.91-98.705-98.705-238.91-98.705-139.589 0-238.602 98.705T142.385-480q0 139.589 99.013 238.602T480-142.385ZM480-480Z"/>
      </svg>
    </div>
    <div class="w-full overflow-x-auto p-2 rounded-lg">
      <h1 class="text-center pt-6 pb-2 font-medium text-xl dark:text-gray-200">Oops..! Tienes algúnos errores</h1>
      <div class="content max-h-72 overflow-y-auto"> <!-- Contenedor con esquinas redondeadas para hacer que la tabla sea scrollable horizontalmente -->
        <table class="w-full text-sm text-left dark:text-blue-100 p-2">
          <thead class="text-sm uppercase dark:text-gray-200">
            <tr class="font-medium">
              <th scope="col" class="px-2 py-1 sticky top-0 bg-white dark:bg-slate-700"> <!-- Agregamos la clase bg-white para que el encabezado tenga un fondo blanco y se superponga al contenido -->
                Nombre del archivo
              </th>
              <th scope="col" class="px-2 py-1 sticky top-0 bg-white dark:bg-slate-700"> <!-- Agregamos la clase bg-white para que el encabezado tenga un fondo blanco y se superponga al contenido -->
                Código de error
              </th>
            </tr>
          </thead>
          <tbody>
            @for (item of combinedItems; track item) {
              <tr>
                <th scope="row" class="px-2 py-1 font-medium dark:text-blue-100">
                  @if (item.name.split('_').length === 6) {
                    {{ item.name.split('_')[0] | uppercase}}_<span [ngClass]="{'text-red-700': item.code === '999'}">{{item.name.split('_')[1]| uppercase}}</span>_<span [ngClass]="{'text-red-700': item.code === '002'}">{{ item.name.split('_')[2]| uppercase}}</span>_{{ item.name.split('_')[3]| uppercase}}_<span [ngClass]="{'text-red-700': item.code === '003'}">{{ item.name.split('_')[4]| uppercase}}</span>_{{ item.name.split('_')[5]| uppercase}}
                  }
                  @if (item.name.split('_').length > 6 || item.name.split('_').length < 6 ) {
                    {{ item.name | uppercase | truncate: 40 }}
                  }
                </th>
                <td class="px-2 py-1">
                  <strong [ngClass]="{'text-red-700': item.code === '999' || item.code === '002' || item.code === '003'}">{{ item.code | uppercase }}</strong>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
    <mat-divider class="dark:bg-slate-600 dark:p-[0.05rem]"></mat-divider>
    <footer class="h-full text-center pt-2 dark:text-gray-400">
      Estos documentos no cumplen con la estructura. <a routerLink="example" class="dark:text-gray-200" (click)="closeDialog()"> Ver Ejemplo</a>
    </footer>
    <div mat-dialog-actions class="flex justify-content-center">
      <button mat-flat-button class="mb-4" color="primary" (click)="closeDialog()" cdkFocusInitial>OK</button>
    </div>
  </div>
  }
  @case ('dialog-deleted-items') {
    <div id="dialog-deleted-items"
    class="bg-white dark:bg-slate-700 border dark:border-slate-700 rounded-lg">
    <div id="icon" class="pt-8 animate-bounce animate-duration-[800ms] animate-delay-490">
      <svg aria-hidden="true" class="mx-auto text-amber-400 w-14 h-14 dark:text-amber-200" fill="none"
        stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
        d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
      </svg>
    </div>
    <h1 mat-dialog-title class="text-center">{{data.message}}</h1>
    <div mat-dialog-content class="h-full text-center">
      <p class="h-full text-center">Este proceso no es reversible, está a punto de eliminar</p> el {{data.typeItem}} {{data.actions}}
    </div>
    <div mat-dialog-actions class="flex justify-content-between">
      <button mat-flat-button color="warn" class="animate-play" (click)="onConfirm()" cdkFocusInitial>Si, Estoy seguro</button>
      <span class="spacer"></span>
      <button mat-flat-button color="primary" (click)="onNoClick()">No, Cancelar</button>
    </div>
  </div>
  }
  @case ('dialog-custom') {
    <div id="dialog-logout"
    class="bg-white dark:bg-slate-700 border dark:border-slate-700 rounded-lg">
    <div id="icon" class="pt-8 animate-flip-up animate-duration-[800ms] animate-delay-490 text-center">
      <mat-icon ngClass="{{data.colorIcon}}">{{data.icon}}</mat-icon>
    </div>
    <h1 class="text-center pt-4 font-medium text-lg dark:text-gray-400 text-gray-800">{{ data.title }}</h1>
    <div mat-dialog-content class="h-full text-center">
      <p class="h-full text-center text-gray-800 dark:text-gray-400">{{data.message}}</p>
    </div>
    <div mat-dialog-actions class="flex justify-content-between">
      <button mat-flat-button color="primary" (click)="onConfirm()" cdkFocusInitial>{{data.confirmButtonText}}</button>
      <span class="spacer"></span>
      <button mat-flat-button color="accent" (click)="onNoClick()">{{data.cancelButtonText}}</button>
    </div>
  </div>
  }
  @case ('dialog-confirm') {
    <div id="dialog-confirm"
    class="bg-white dark:bg-slate-700 border dark:border-slate-700 rounded-lg">
    <div id="icon" class="pt-8 animate-flip-up animate-ease-in animate-duration-[500ms] animate-delay-490 text-center">
      <mat-icon ngClass="{{data.colorIcon}}">{{data.icon}}</mat-icon>
    </div>
    <h1 class="text-center pt-4 font-medium text-lg dark:text-gray-400 text-gray-800">{{ data.title }}</h1>
    <div mat-dialog-content class="h-full text-center">
      <p class="h-full text-center text-gray-800 dark:text-gray-400">{{data.message}}</p>
    </div>
    <div mat-dialog-actions class="flex justify-content-between">
      <button mat-flat-button color="primary" (click)="onConfirm()" cdkFocusInitial>{{data.confirmButtonText}}</button>
    </div>
  </div>
  } @case ('dialog-anuncios') {

    <section class=" bg-white dark:bg-slate-800 w-auto">
      <div class="bg-white dark:bg-slate-800 rounded-lg shadow-md p-8 max-w-lg mx-auto">
        <h2 class="text-2xl font-semibold mb-4 dark:text-gray-400 text-verde">¡Actualización de la App SADIS!</h2>
        <p class="dark:text-gray-500 text-gray-900 mb-2">Estamos emocionados de anunciar una nueva actualización para SADIS, nuestro gestor de archivos ecológico. Hemos escuchado tus comentarios y hemos implementado las siguientes mejoras:</p>

        <ul class="list-disc pl-6 mb-1">
            <li class="mb-2 dark:text-gray-400">
              <strong class="text-verde">¡Novedad! Asignación de usuarios al cargar documentos masivamente:</strong><br>
              Ahora tienes la opción de asignar usuarios al subir documentos en modo masivo, de manera individual. Esto significa que al cargar varios documentos simultáneamente, puedes especificar a qué usuario se asignarán los folios correspondientes.<br><br>

              Por ejemplo, si estás subiendo 4 documentos en el módulo de Carga Masiva Individual y seleccionas un usuario en el campo "Asignar a", los folios de los 4 documentos se asignarán a ese usuario. En caso de no seleccionar una opción, los folios se asignarán al usuario que está realizando la carga.<br><br>

              Esta funcionalidad te brinda mayor flexibilidad y control sobre la asignación de documentos, permitiéndote gestionar de manera eficiente el flujo de trabajo en tu aplicación SADIS.
            </li>
        </ul>

        <p class="dark:text-gray-500 mb-2">¡Esperamos que estas mejoras hagan que tu experiencia con SADIS sea aún más placentera y eficiente! No dudes en ponerte en contacto con nuestro equipo de soporte si necesitas ayuda o tienes alguna pregunta.</p>

        <div class="flex justify-end pt-1">
            <button mat-flat-button color="primary" (click)="closeDialog()" class="bg-verde text-white px-4 py-2 rounded-md">Ok, Continuar</button>
        </div>
      </div>



    </section>


  }
}








